import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useEffect} from "react";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {useApp} from "../../providers/RegionProvider/RegionProvider";
import {useAuth} from "../../providers/AuthProvider/AuthProvider";
import {ActivityPeriodProfilePage as ActivityPeriodProfilePageTw} from "@ots-frontend/ots-ui-tw";

type Props = {
  id?: string;
}

export const ActivityPeriodProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage message={"Activity Period Not Found"}/>
    );
  }

  return <ActivityPeriodProfilePage id={id}/>;
};

export const ActivityPeriodProfilePage = (props: Props) => {
  const {id} = props;

  const navigate = useNavigate()
  const {pathname, search, state} = useLocation()
  const {appCategory} = useApp()
  const {user, hasAccess} = useAuth()

  useEffect(() => {
    navigate(pathname + search, {replace: true, state: {...state, category: appCategory?.code}})
  }, [])

  if (!id) return <ErrorPage message={"Activity Period Not Found"}/>;

  const isSuperAdmin = user?.roles?.some(role => role.key === "SUPER_ADMIN") ?? false;
  return <ActivityPeriodProfilePageTw
    id={id}
    density="default"
    brand="water-go"
    colorScheme="system"
    allowAddComment={hasAccess("edit")}
    showSummaryActions={isSuperAdmin}
    onClose={() => navigate(-1)}/>;
};
